import { keyof, nullType, string, type, union } from 'io-ts';

const SectionType = keyof({
    events: null,
    shopping: null,
    offers: null,
    accommodations: null,
    activities: null,
    information: null,
});

export const SearchParamsType = type({
    query: string,
    section: union([SectionType, nullType]),
}, 'SearchParams');
